/**
 * To determine any aditional load is added by updating indexs after last run time
 * @param indexs list of indexs for verify any index is updated after run report
 * @returns true if any index updated due to aditional loaded added after last run time
 * */
export const checkAdditionalLoadByIndexUpdate = (
  indexs: {startDateTime: string}[],
  reportRunTime?: string
): boolean => {
  const providedDate = new Date(reportRunTime ?? '');

  /**
   * If any index is updated after last run then return true so all term will ber run
   */
  const isIndexUpdated: boolean = indexs.some((item) => {
    const itemDate = new Date(item.startDateTime);
    return itemDate > providedDate;
  });
  if (isIndexUpdated) return true;

  return false;
};
